import { useFocusEffect, useLocalSearchParams } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { selectedMembershipIdAtom } from '../../../entities/entityAtoms';
import RetirementCalculator from '../../../retirement-calculator/components/RetirementCalculatorPage';

const RetirementCalculatorPage = () => {
    const { membershipId } = useLocalSearchParams<{
        membershipId: string;
    }>();

    const setSelectedMembershipId = useSetAtom(selectedMembershipIdAtom);

    // This effect will only run once per membership because each membership details page
    // is rendered separately in a navigation stack (thus, going back to previously viewed
    // memberships is fast)
    useEffect(() => {
        setSelectedMembershipId(membershipId);
    }, [membershipId]);

    // This effect will run every time a membership is re-visited
    // so if the data fetch for this membership wasn't completed on the first visit,
    // this will trigger a new request for the data
    useFocusEffect(
        useCallback(() => {
            setSelectedMembershipId(membershipId);
        }, [membershipId]),
    );

    return <RetirementCalculator />;
};

export default RetirementCalculatorPage;
